module.exports = __webpack_public_path__ + "static/media/fly0264.b9218cdd.webp";